import {
  Box,
  Link,
  // styled,
  // Tooltip,
  // tooltipClasses,
  // TooltipProps,
  useTheme,
} from "@mui/material";
import CopyButton from "../copy-button";
import { useAuthContext } from "@/auth/useAuthContext";
// import { useLocales } from "@/locales";

type Props = {
  url: string;
};

export default function PostRequest({ url }: Props) {
  const theme = useTheme();
  // const { translate } = useLocales();
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  // const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  //   <Tooltip {...props} classes={{ popper: className }} />
  // ))(({ theme }) => ({
  //   [`& .${tooltipClasses.tooltip}`]: {
  //     maxWidth: "none",
  //     background: "var(--Background-default)",
  //     color: "var(--Text-main)",
  //     fontWeight: 500,
  //     fontSize: "14px",
  //     lineHeight: "24px",
  //     padding: "12px",
  //     borderRadius: "8px",
  //     // filter: `drop-shadow(${'var(--CustomShadows-dropdown)'})`,
  //     boxShadow:
  //       "-20px 20px 40px 0px rgba(113, 117, 126, 0.16), 0px 0px 2px 0px rgba(113, 117, 126, 0.16)",
  //     letterSpacing: "0.1px",
  //   },
  //   [`& .MuiTooltip-arrow::before`]: {
  //     color: "var(--Background-default)",
  //     background: "#fff",
  //     boxShadow:
  //       "-20px 20px 40px 0px rgba(113, 117, 126, 0.16), 0px 0px 2px 0px rgba(113, 117, 126, 0.16)",
  //   },
  // }));
  return (
    <Box
      component={"div"}
      className="desc"
      sx={{ display: "flex", alignItems: "center" }}
    >
      POST{" "}
      {check ? (
        <>
          <Link
            className="link"
            underline="always"
            sx={{
              wordBreak: "break-all",
            }}
          >
            {url}
          </Link>
          <CopyButton
            source={url}
            color={theme.palette?.NightText?.secondary}
          />
        </>
      ) : (
        <span>
          {"  "}
          ***
          {/* <NoMaxWidthTooltip
            placement="right"
            title={translate("common.login")}
            arrow
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              style={{
                marginLeft: "8px",
              }}
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.7868 5.96749C19.1729 6.21789 19.283 6.73392 19.0326 7.12008C18.4369 8.0387 17.6558 8.79054 16.7514 9.38315L18.6461 11.071C18.9898 11.3772 19.0202 11.9039 18.7141 12.2476C18.4079 12.5912 17.8812 12.6217 17.5375 12.3155L15.5063 10.5061C15.3992 10.4107 15.3226 10.2938 15.277 10.1678C14.6169 10.4489 13.918 10.6641 13.1974 10.8156L13.9679 13.0631C14.1172 13.4985 13.8853 13.9724 13.4499 14.1216C13.0145 14.2709 12.5406 14.039 12.3913 13.6036L11.5166 11.0521C11.1838 11.0768 10.8493 11.0892 10.5147 11.0892C10.1429 11.0892 9.76848 11.0742 9.39324 11.0441L8.51576 13.6036C8.3665 14.039 7.89257 14.2709 7.45721 14.1216C7.02185 13.9724 6.78991 13.4985 6.93917 13.0631L7.71246 10.8075C6.88075 10.6393 6.05877 10.3954 5.26707 10.0747C5.22928 10.236 5.14319 10.3875 5.01015 10.5061L2.97897 12.3155C2.63531 12.6217 2.10855 12.5912 1.80241 12.2476C1.49628 11.9039 1.52669 11.3772 1.87034 11.071L3.7874 9.36325C2.78126 8.79632 1.85451 8.088 1.05791 7.23572C0.743636 6.89949 0.761441 6.37215 1.09767 6.05788C1.43391 5.74361 1.96124 5.76141 2.27551 6.09765C4.32592 8.29135 7.47922 9.42287 10.5145 9.42253C13.5645 9.42218 16.2893 8.28725 17.6342 6.21329C17.8846 5.82713 18.4006 5.71708 18.7868 5.96749Z"
                fill="#71757E"
              />
            </svg>
          </NoMaxWidthTooltip> */}
        </span>
      )}
    </Box>
  );
}
